function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconRoomBridgeViewFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 4H4v24h24V4zM4 2a2 2 0 00-2 2v24a2 2 0 002 2h24a2 2 0 002-2V4a2 2 0 00-2-2H4z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 8a1 1 0 012 0v15H7V8zM10 14h2v5h-2v-5zM13 15h2v4h-2v-4zM17 15h2v4h-2v-4zM20 14h2v5h-2v-5z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.007 13.208C21.584 14.626 19.273 16 15.742 16c-3.536 0-5.737-1.38-7.044-2.83a8.065 8.065 0 01-1.305-1.965 6.824 6.824 0 01-.336-.865 3.2 3.2 0 01-.018-.062l-.005-.02-.002-.008-.001-.003v-.001L8 10l.97-.246-.001-.002V9.75v.002l.006.02.037.117c.037.107.099.27.192.468.187.4.496.937.98 1.474.944 1.048 2.613 2.169 5.558 2.169 2.95 0 4.767-1.126 5.853-2.208.552-.55.925-1.1 1.158-1.507a5.538 5.538 0 00.306-.623v.001s-.001.002.941.337l.942.336v.001l-.002.003-.002.007-.007.02a5.097 5.097 0 01-.107.257 7.554 7.554 0 01-.335.654 9.17 9.17 0 01-1.482 1.93zm.052-3.546V9.66v.002z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 18s5-1 11-1 11 1 11 1v2s-5-1-11-1-11 1-11 1v-2zM22 24a1 1 0 011-1h2a1 1 0 011 1v1h-4v-1zM6 24a1 1 0 011-1h2a1 1 0 011 1v1H6v-1z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 8a1 1 0 112 0v15h-2V8z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 12.275V10l.97-.246v-.001l-.001-.002V9.75v.002l.006.022.037.116c.037.107.099.269.192.468A6.067 6.067 0 0027 12.584v2.358a8.077 8.077 0 01-3-2.667zM8 10a76.34 76.34 0 01-.97-.246v-.001l.001-.002V9.75",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 12.275a8.078 8.078 0 01-3 2.667v-2.358a6.065 6.065 0 001.796-2.227 4.836 4.836 0 00.235-.606V9.75",
    fill: props.color
  }));
}

export default SvgIconRoomBridgeViewFilled;